import { Injectable } from '@angular/core';

import { FavoriteModel } from '../../../../ui/my/routes/my-home/components/my-favorite-save-modal/my-favorite-save-modal.component';
import { FavoriteDiary } from '../../../patient/domain/favorite-diary/favorite-diary';
import { Patient } from '../../../patient/domain/patient';
import { FavoriteDiaryRepository } from '../../../patient/repositories/favorite-diary.repository';
import { DiaryTypeRepository } from '../../repositories/diary_type_repository';
import { TrackerRepository } from '../../repositories/tracker_repository';
import { Tracker } from '../tracker/tracker';
import { DiaryType } from './diary_type';

@Injectable()
export class DiaryTypeCommands {
  constructor(
    private diaryTypeRepository: DiaryTypeRepository,
    private favoriteDiaryRepository: FavoriteDiaryRepository,
    private trackerRepository: TrackerRepository,
  ) {
    // Nada
  }

  async findAllMyDiaryTypes(
    patientId: string,
    dietitianId: string | undefined,
  ) {
    let diaryTypes = await this.diaryTypeRepository.findAllPatient(patientId);
    if (!diaryTypes || diaryTypes.length === 0) {
      if (dietitianId) {
        diaryTypes = await this.diaryTypeRepository.findAllDietitian(
          dietitianId,
        );
        if (!diaryTypes || diaryTypes.length === 0) {
          diaryTypes = await this.diaryTypeRepository.findAllDefault();
        }
      } else {
        diaryTypes = await this.diaryTypeRepository.findAllDefault();
      }
    }
    return diaryTypes;
  }

  async findAllDiaryTypes(
    dietitianId: string | undefined,
    groupId: string | undefined,
    patientId: string | undefined,
  ) {
    // Case Patient
    if (patientId) {
      let diaryTypes = await this.diaryTypeRepository.findAllPatient(patientId);
      if (!diaryTypes || diaryTypes.length === 0) {
        diaryTypes = await this.diaryTypeRepository.findAllDefault();
      }
      return diaryTypes;
    }
    // Case Patient Group
    else if (groupId) {
      let diaryTypes = await this.diaryTypeRepository.findAllPatientGroup(
        groupId,
      );
      if (!diaryTypes || diaryTypes.length === 0) {
        diaryTypes = await this.diaryTypeRepository.findAllDefault();
      }
      return diaryTypes;
    }
    // Case Dietitian
    else if (dietitianId) {
      let diaryTypes = await this.diaryTypeRepository.findAllDietitian(
        dietitianId,
      );
      if (!diaryTypes || diaryTypes.length === 0) {
        diaryTypes = await this.diaryTypeRepository.findAllDefault();
      }
      return diaryTypes;
    }
    // Case Default
    else {
      return this.diaryTypeRepository.findAllDefault();
    }
  }

  async saveAllDiaryTypeToGroup(
    diaryTypes: DiaryType[],
    patientGroupId: string,
  ) {
    for (const event of diaryTypes) {
      await this.diaryTypeRepository.saveToPatientGroup(event, patientGroupId);
    }
  }

  async saveDiaryType(
    diaryType: DiaryType,
    dietitianId: string | undefined,
    patientGroupId: string | undefined,
    patientId: string | undefined,
  ) {
    const events = await this.findAllDiaryTypes(
      dietitianId,
      patientGroupId,
      patientId,
    );
    for (const event of events) {
      if (event.name === diaryType.name) {
        event.label = diaryType.label;
        event.hint = diaryType.hint;
        event.displayed = diaryType.displayed;
      }
      if (patientId) {
        await this.diaryTypeRepository.saveToPatient(event, patientId);
      } else if (patientGroupId) {
        await this.diaryTypeRepository.saveToPatientGroup(
          event,
          patientGroupId,
        );
      } else if (dietitianId) {
        await this.diaryTypeRepository.saveToDietitian(event, dietitianId);
      }
    }
  }

  async createAllDiaryTypeToPatient(
    diaryTypes: DiaryType[],
    patientId: string,
  ) {
    await this.diaryTypeRepository.saveBatch(diaryTypes, patientId);
  }

  async findAllFavoriteDiaries(
    patientId: string,
    diaryType: DiaryType | undefined = undefined,
  ) {
    if (diaryType) {
      return this.favoriteDiaryRepository.findAllByDiaryType(
        patientId,
        diaryType,
      );
    } else {
      return this.favoriteDiaryRepository.findAll(patientId);
    }
  }

  async saveFavoriteDiary(
    favorite: FavoriteModel,
    diaryType: DiaryType,
    patientId: string,
  ) {
    return this.favoriteDiaryRepository.save(
      {
        title: favorite.title,
        content: favorite.description,
      },
      diaryType,
      patientId,
    );
  }

  async updateFavoriteDiary(favoriteDiary: FavoriteDiary, patientId: string) {
    return this.favoriteDiaryRepository.update(favoriteDiary, patientId);
  }

  async findTrackersByPatientAndDiaryType(
    patient: Patient,
    diaryType: DiaryType,
  ): Promise<Tracker[]> {
    return this.trackerRepository.findTrackersByPatientIdAndDiaryType(
      patient.id.toString(),
      diaryType,
    );
  }
}
